module.exports = __webpack_public_path__ + "media/images/dashboards/prescribing-4af91aee39ec887ed5552520a506bca6.png";